import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

const Our_Mission = () => {
  return (
    <>
      <Banner />
      <div className="home_header">
        <h1 className="home_header">Mission</h1>
      </div>

      <div className="mission_info">
        <p>
          We strive to provide our esteemed clients with a professional standard
          of quality service by understanding their needs and
          <br />
          translating business advice into measurable market results. We aim to
          bring invaluable insight and growth to our clients by
          <br />
          building a long-term relationship based on trust and our reputation in the field of media and marketing.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Our_Mission;
